import { Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import { InscricaoAluno } from '../inscricao-aluno/inscricao-aluno';
import { InscricaoAlunoService } from '../inscricao-aluno/inscricao-aluno.service';
import { MatSnackBar } from '@angular/material';
import { SituacaoEnum } from '../util/situacao.enum';
import { TipoValidacaoAlunoEnum } from '../util/tipo-validacao-aluno.enum';
import { NavegarValidacao } from './navegar-validacao';

@Component({
  selector: 'navegar-validacao',
  templateUrl: './navegar-validacao.component.html'
})
export class NavegarValidacaoComponent implements OnInit {

  @Input() tipo: number;
  @Input() periodo: string;
  @Input() nomeBotao: "Próximo";

  @Output() idIscricaoEmitida: EventEmitter<NavegarValidacao> = new EventEmitter<NavegarValidacao>();;

  private filtro: InscricaoAluno;


  constructor(private inscricaoAlunoService: InscricaoAlunoService,   private mensagem: MatSnackBar) { }

  ngOnInit() {
    this.filtro = new InscricaoAluno();
    this.filtro.periodo =  this.periodo;
  }

  // pego o próximo
  proximo(idUsuario){
    this.inscricaoAlunoService.filtrar(this.filtro).subscribe ((lista: InscricaoAluno[]) => {
        let idEncontrado: number = null;
        let posicao: number = 0;
        const storage = JSON.parse(localStorage.getItem("editaldpg"));
        let idUsuarioLogado: number =  storage["codigo"];
        for(let inscrito of lista){
          posicao ++;

          if(inscrito.usuarioAtribuido == null || inscrito.usuarioAtribuido == undefined ||  inscrito.usuarioAtribuido === idUsuarioLogado){
            if(inscrito.situacao == SituacaoEnum.Inscrito.id){
              idEncontrado = inscrito.id;
              break;
            }else if (this.tipo == TipoValidacaoAlunoEnum.Tecnico.id){
              // se for tecnico entao verifico se for deferido Academico
              if(inscrito.situacao == SituacaoEnum.DeferidoAcademico.id){
                idEncontrado = inscrito.id;
                break;
              }
            }else if(this.tipo == TipoValidacaoAlunoEnum.Academico.id){
              if(inscrito.situacao == SituacaoEnum.DeferidoTecnico.id){
                idEncontrado = inscrito.id;
                break;
              }
            }
          }
        }

        if(idEncontrado){
          let navegar: NavegarValidacao = new NavegarValidacao();
          navegar.idInscricao = idEncontrado;
          navegar.posicao = posicao;
          this.idIscricaoEmitida.emit(navegar);
        }else{
          // se nao encontrar ninguem, emite null
          this.idIscricaoEmitida.emit(null);
        }

      }, error =>  this.erro(error)
    );
  }

  // mostra erros na tela
 erro(erro: string){
     this.mensagem.open(erro, 'X', {duration: 5000});
 }


}
